<div class="authincation h-100">
  <div class="container">
    <div class="row justify-content-center h-100 align-items-center">
      <div class="col-md-6">
        <div class="error-page">
          <div class="error-inner text-center">
            <div class="dz-error">
              <img
                src="../../../assets/logos/core/acibadem-mobil-logo.png"
                alt="Logo"
                style="width: 100%; height: auto"
              />
            </div>
            <h2 class="error-head">
              We are sorry. But the page you are looking for cannot be found.
            </h2>
            <a href="#" (click)="goHomePage()" class="btn btn-secondary" (keydown.enter)="goHomePage()"
              >BACK TO HOMEPAGE</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
